import { Input } from 'components'
import { memo, useRef } from 'react'
import * as S from './styles'

import { Controller, useFormContext, useWatch } from 'react-hook-form'
interface ItemSizeProps {
  colorName: string
  size: string
  disabled?: boolean
}

function ItemSize({ colorName, size, disabled }: ItemSizeProps) {
  return (
    <>
      <MyInput size={size} colorName={colorName} disabled={disabled} />
    </>
  )
}

export default ItemSize

const MyInput = memo(function MyInput({ colorName, size, disabled }: ItemSizeProps) {
  const { control } = useFormContext()
  const inputRef = useRef<HTMLInputElement>(null)

  const [watchedMixedBox, watchedQtdMixedBox] = useWatch({
    control: control,
    name: ['fl_caix_grad', 'qt_caix_grad']
  })

  return (
    <>
      <Controller
        name={`[${colorName}].${size}`}
        control={control}
        defaultValue=""
        render={({ field: { name, onChange, value }, fieldState: { invalid } }) => {
          const convertedValue =
            watchedMixedBox && value ? `(${value * Number(watchedQtdMixedBox)})` : 1
          return (
            <>
              <Input
                id={`input-amount-${colorName.toLowerCase()}-${size}`}
                name={name}
                value={value || ''}
                onChange={(e) => {
                  const currentValue = e.target.value.replace(/\D/, '')
                  const parsedCurrentValue = currentValue ? parseInt(currentValue) : 0
                  onChange(parsedCurrentValue)
                }}
                height={30}
                width={80}
                disabled={disabled}
                InputProps={{
                  inputProps: { maxLength: 6 }
                }}
                errorOutline={invalid}
                maxLength={watchedMixedBox ? 2 : 6}
                browserAutocomplete="off"
                ref={inputRef}
              />
              {!!value && watchedMixedBox && (
                <S.MixedBoxValue onClick={() => inputRef.current?.focus()}>
                  {convertedValue}
                </S.MixedBoxValue>
              )}
            </>
          )
        }}
      />
    </>
  )
})
